<template>
    <div class="col-12 col-md-5 section-herramientas__col">
        <div class="section-herramientas__contenedor-superior">
            <img class="section-herramientas__img" src="/icons/multicolor/historico.svg">
            <h3 class="section-herramientas__title">Histórico de procesos</h3>
        </div>
        <div class="section-herramientas__info">
            <p>{{ $t(`${this.$root.pais_actual == 'panama' ? 'pan' : 'all' }.historico_procesos.texto`, {anio: anio, fuentes: fuentes}) }}</p>
            
        </div>
    </div>
</template>

<script>
export default {
    name: 'HistoricoProcesos',
    data() {
        return {
            pais: {},
        }
    },
    computed: {
        anio() {
            return this.$root.paises.filter(pais => pais.alias.toLowerCase() === this.$root.alias_pais.toLowerCase())
                .map(pais => {
                    if (pais.fecha_publicacion_primer_proceso != null) {
                        return new Date(pais.fecha_publicacion_primer_proceso).getFullYear();
                    } else {
                        return new Date().getFullYear();
                    }
                })[0];
        },
        fuentes() {
            return this.$root.paises.filter(pais => pais.alias.toLowerCase() === this.$root.alias_pais.toLowerCase())
                .map(pais => {
                    return pais.fuentes;
                })[0];
        }
    }
}
</script>